import React, { useState }          from "react";
import { useNavigate }               from "react-router-dom";
import { adminLogin, resetPassword } from "../services/authService";
import toast                         from "react-hot-toast";
import { Lock, Mail, Eye, EyeOff }   from "lucide-react";
import businessConfig                from "../config/businessConfig";

export default function AdminLogin() {
  const [email,    setEmail]    = useState("");
  const [password, setPassword] = useState("");
  const [showPw,   setShowPw]   = useState(false);
  const [loading,  setLoading]  = useState(false);
  const [forgotPw, setForgotPw] = useState(false);
  const navigate = useNavigate();

  // ── Real Firebase login ───────────────────────────────────
  async function handleLogin(e) {
    e.preventDefault();
    setLoading(true);
    const result = await adminLogin(email, password);
    setLoading(false);
    if (result.success) {
      toast.success("Welcome back, Admin!");
      navigate("/admin");
    } else {
      toast.error("Wrong email or password. Try again.");
    }
  }

  // ── Password reset ────────────────────────────────────────
  async function handleResetPassword(e) {
    e.preventDefault();
    if (!email) { toast.error("Enter your admin email first."); return; }
    const result = await resetPassword(email);
    if (result.success) {
      toast.success("Password reset email sent!");
      setForgotPw(false);
    } else {
      toast.error("Failed to send reset email.");
    }
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-900 to-purple-900 flex items-center justify-center p-4">
      <div className="bg-white rounded-3xl shadow-2xl w-full max-w-sm p-8">

        {/* Logo */}
        <div className="text-center mb-6">
         <div className="flex justify-center mb-3">
  <img 
    src={businessConfig.logo} 
    alt={businessConfig.name} 
    className="h-16 w-auto"
  />
</div>
          <h2 className="text-2xl font-bold text-gray-800">Admin Login</h2>
          <p className="text-gray-500 text-sm mt-1">
            {businessConfig.name} Control Panel
          </p>
        </div>

        {/* Form */}
        <form onSubmit={forgotPw ? handleResetPassword : handleLogin} className="space-y-4">
          <div className="relative">
            <Mail size={16} className="absolute left-3 top-3.5 text-gray-400"/>
            <input
              type="email" required value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="Admin email address"
              className="w-full pl-9 pr-4 py-3 rounded-xl border border-gray-200 text-sm focus:outline-none focus:border-indigo-400"
            />
          </div>

          {!forgotPw && (
            <div className="relative">
              <Lock size={16} className="absolute left-3 top-3.5 text-gray-400"/>
              <input
                type={showPw ? "text" : "password"} required value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="Password"
                className="w-full pl-9 pr-10 py-3 rounded-xl border border-gray-200 text-sm focus:outline-none focus:border-indigo-400"
              />
              <button
                type="button" onClick={() => setShowPw(!showPw)}
                className="absolute right-3 top-3.5 text-gray-400 hover:text-gray-600"
              >
                {showPw ? <EyeOff size={16}/> : <Eye size={16}/>}
              </button>
            </div>
          )}

          <button
            type="submit" disabled={loading}
            className="w-full bg-indigo-600 text-white py-3 rounded-xl font-bold hover:bg-indigo-700 transition-colors disabled:opacity-50"
          >
            {loading ? "Please wait…" : forgotPw ? "Send Reset Email" : "Sign In"}
          </button>
        </form>

        {/* Links */}
        <div className="mt-4 space-y-2 text-center">
          <button
            onClick={() => setForgotPw(!forgotPw)}
            className="block w-full text-indigo-600 text-sm hover:underline"
          >
            {forgotPw ? "← Back to login" : "Forgot password?"}
          </button>
          <a href="/" className="block text-gray-400 text-sm hover:text-gray-600">
            ← Back to Website
          </a>
        </div>
      </div>
    </div>
  );
}